import React from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Typography,
  IconButton,
  makeStyles,
  Box,
} from '@material-ui/core';
import CloseIcon from '@material-ui/icons/Close';

const useStyles = makeStyles((theme) => ({
  dialogTitle: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    padding: theme.spacing(2),
    paddingBottom: 0,
  },
  closeButton: {
    position: 'absolute',
    right: theme.spacing(1),
    top: theme.spacing(1),
  },
  content: {
    padding: theme.spacing(3),
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
  },
  actions: {
    justifyContent: 'center',
    padding: theme.spacing(2),
    paddingTop: 0
  },
  title: {
    fontSize: 20,
    fontWeight: 'bold',
    marginBottom: theme.spacing(2),
    marginTop: theme.spacing(4),
    textAlign: 'center',
  },
  noButton: {
    borderRadius: '2rem',
    padding: '8px 32px',
    backgroundColor: '#fff',
    color: '#000',
    textTransform: 'none',
    border: '1px solid #000',
    '&:hover': {
      backgroundColor: '#f5f5f5',
    },
  },
  yesButton: {
    borderRadius: '2rem',
    padding: '8px 32px',
    backgroundColor: '#ec6535',
    color: '#fff',
    textTransform: 'none',
    marginRight: theme.spacing(2),
    '&:hover': {
      backgroundColor: '#d85a2f',
    },
  },
  cancelButton: {
    position: 'absolute',
    right: theme.spacing(2),
    top: theme.spacing(2),
    color: '#000',
    fontWeight: 'bold',
  },
}));

const AddProductDialog = ({ open, onClose, onYes, onNo, selectedSupplytype }) => {
  const classes = useStyles();

  return (
    <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
      <Box position="relative">
        <Button onClick={onClose} className={classes.cancelButton}>
          Cancel
        </Button>
      </Box>
      <DialogContent className={classes.content}>
        <Typography variant="h5" className={classes.title}>
          Is the product already added in the system for {selectedSupplytype?.supplyTypeName}?
        </Typography>
      </DialogContent>
      <DialogActions className={classes.actions}>
        <Button disabled={!selectedSupplytype ? true : false} onClick={onYes} className={classes.yesButton}>
          Yes
        </Button>
        <Button onClick={onNo} className={classes.noButton}>
          No
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default AddProductDialog;
